var alignmentStyle = {"alignLeft":"PDaVo","textWrapNowrap":"l7amA","alignRight":"_1krhB","alignCenter":"kh9zY","sizeFullWidth":"_4vdp8","renderedInTable":"UoXhP","sizeOriginal":"aKxFY","sizeContent":"u1sg6","sizeSmall":"md3hU","sizeSmallCenter":"_9KT2O","flex":"IQhP-","LEFT":"OVBOz","CENTER":"pm6Pb","RIGHT":"-BU0q","AUTO":"_3vz8z","JUSTIFY":"nn5Qj"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-7d113dfa.js.map
